import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewTransactionDetailComp  from "./Component/ViewTransactionDetailComp"

const ViewTransactionDetail =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewTransactionDetailComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewTransactionDetail